import React, { useState } from 'react';
import { Search } from 'lucide-react';

const FinancialFormulas = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const formulas = [
    // Likidite Oranları
    {
      category: "Likidite Oranları",
      formulas: [
        {
          title: "Cari Oran",
          formula: "Mevcut Varlıklar / Mevcut Yükümlülükler",
          description: "Şirketin kısa vadeli borçlarını ödeme kabiliyetini ölçer"
        },
        {
          title: "Hızlı Oran",
          formula: "(Nakit + Nakit Benzerleri + Kısa Vadeli Yatırımlar + Alacaklar) / Kısa Vadeli Yükümlülükler",
          description: "Şirketin stoklarını satmadan borçlarını ödeme yeteneğini gösterir"
        },
        {
          title: "Nakit Oranı",
          formula: "Nakit ve Nakit Benzerleri / Kısa Vadeli Yükümlülükler",
          description: "Şirketin nakit varlıklarıyla borçlarını karşılama oranı"
        }
      ]
    },
    // Karlılık Oranları
    {
      category: "Karlılık Oranları",
      formulas: [
        {
          title: "Brüt Kar Marjı",
          formula: "Brüt Kar / Satışlar",
          description: "Şirketin satış karlılığını gösterir"
        },
        {
          title: "Net Kar Marjı",
          formula: "Net Kar / Satışlar",
          description: "Şirketin nihai karlılığını gösterir"
        },
        {
          title: "ROE (Özkaynak Karlılığı)",
          formula: "Net Kar / Özkaynaklar",
          description: "Şirketin özkaynak verimliliğini ölçer"
        }
      ]
    },
    // Değerleme Oranları
    {
      category: "Değerleme Oranları",
      formulas: [
        {
          title: "F/K (Fiyat/Kazanç)",
          formula: "Hisse Fiyatı / Hisse Başına Kar",
          description: "Şirketin piyasa değerinin kazancına oranı"
        },
        {
          title: "PEG Oranı",
          formula: "F/K / Yıllık Kar Büyüme Oranı",
          description: "F/K'nın büyüme oranına göre düzeltilmiş hali"
        },
        {
          title: "Piyasa Değeri/Defter Değeri",
          formula: "Piyasa Değeri / Özkaynak",
          description: "Şirketin piyasa değerinin defter değerine oranı"
        }
      ]
    },
    // ... (diğer tüm formüller bu şekilde gruplandırılarak eklenecek)
  ];

  const filteredFormulas = formulas.flatMap(category => 
    category.formulas.filter(formula =>
      formula.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      formula.description.toLowerCase().includes(searchTerm.toLowerCase())
    ).map(formula => ({...formula, category: category.category}))
  );

  return (
    <div className="min-h-screen bg-[#0A0E23] text-white">
      <div className="relative overflow-hidden bg-[#0A0E23] py-24">
        <div className="container mx-auto px-4 max-w-6xl">
          <h1 className="text-4xl font-bold mb-6">Finansal Formüller</h1>
          <p className="text-gray-300 mb-8">
            Finansal oranlar yatırımcılar için değerli araçlar olarak hizmet eder ve zaman dilimleri boyunca finansal sonuçları ve eğilimleri kapsamlı bir şekilde değerlendirmelerini sağlar.
          </p>
          
          <div className="relative max-w-md">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Formül ara..."
              className="w-full pl-10 pr-4 py-2 bg-[#1A1F37] border border-gray-700 rounded-lg focus:outline-none focus:border-blue-500"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12 max-w-6xl">
        {searchTerm ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {filteredFormulas.map((formula, index) => (
              <div 
                key={index}
                className="group relative p-6 bg-[#1A1F37] rounded-lg border border-gray-700 hover:border-blue-500 transition-all duration-300"
              >
                {/* Blue glow effect */}
                <div className="absolute inset-0 rounded-lg bg-blue-500/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                
                {/* Content */}
                <div className="relative z-10">
                  <div className="text-blue-400 text-sm mb-2">{formula.category}</div>
                  <h3 className="text-xl font-semibold mb-3">{formula.title}</h3>
                  <div className="text-blue-400 font-mono mb-3 text-sm">{formula.formula}</div>
                  <p className="text-gray-400 text-sm">{formula.description}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          formulas.map((category, categoryIndex) => (
            <div key={categoryIndex} className="mb-12">
              <h2 className="text-2xl font-bold mb-6">{category.category}</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {category.formulas.map((formula, formulaIndex) => (
                  <div 
                    key={formulaIndex}
                    className="group relative p-6 bg-[#1A1F37] rounded-lg border border-gray-700 hover:border-blue-500 transition-all duration-300"
                  >
                    {/* Blue glow effect */}
                    <div className="absolute inset-0 rounded-lg bg-blue-500/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    
                    {/* Content */}
                    <div className="relative z-10">
                      <h3 className="text-xl font-semibold mb-3">{formula.title}</h3>
                      <div className="text-blue-400 font-mono mb-3 text-sm">{formula.formula}</div>
                      <p className="text-gray-400 text-sm">{formula.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default FinancialFormulas;